import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { BackupMetadata, BackupMetaDataResult, BackupPathMetaData } from '../../models';
import { IUploadService } from '../../services';

export interface IDataBackupConfiguration {
    beginDate?: string;
    endDate?: string;
    includeModel?: boolean;
    includeLogs?: boolean;
}

export interface IDataBackupRestoreService {
    backup(beginDate: string, endDate: string, includeModel?: boolean, includeLogs?: boolean): angular.IPromise<BackupMetadata>;
    upload(file: File): angular.IPromise<BackupMetaDataResult>;
}

export class DataBackupRestoreService implements IDataBackupRestoreService {
    private _controllerUrl = 'dataBackupRestore';

    static serviceId = 'dataBackupRestoreService';
    static $inject = [
        'requestService',
        'uploadService'
    ];

    constructor(
        private _requestService: IRequestService,
        private _upload: IUploadService
    ) {
    }

    backup(beginDate: string, endDate: string, includeModel = false, includeLogs = false): angular.IPromise<BackupMetadata> {
        const url = `${this._controllerUrl}/backup`;
        const args = { beginDate, endDate, includeModel, includeLogs };
        this._requestService.cleanCacheAtV1(url, args);
        return this._requestService
            .getAtV1<BackupPathMetaData>(url, args)
            .then(data => {
                window.open(this._requestService.getApiUrl() + data.item1);
                return data.item2;
            });
    }

    upload(file: File): angular.IPromise<BackupMetaDataResult> {
        const url = `${this._requestService.getUrlV1()}${this._controllerUrl}/upload`;
        return this._upload
            .uploadFile<BackupMetaDataResult>(url, file)
            .then(data => data);
    }
}